import gql from 'graphql-tag';

const FRAGMENT_DEVICE_HISTORY = gql`
  fragment deviceHistoryDetails on DeviceHistory {
    id
    workspaceId
    data
    raw
    deviceId
    eventId
    situationId
    isSelfGenerated
    generatedAt
    receivedAt
  }
`;

export default {
  FRAGMENT_DEVICE_HISTORY,
};
